import { useSuspenseQuery, type UseSuspenseQueryResult } from '@tanstack/react-query';

import { type OffersResponseData } from '@cx-modules/offers-delivery-api-service';

import { type OffersSlimProps } from '../../contract';
import { fetchOffersSlimData, getOffersSlimCacheKey } from '../api/offers-delivery-api.service';

const normaliseOffersSlimData = (data: OffersResponseData | null) => {
  if (!data) return data;

  return data.map(item => {
    if ('code' in item.bookmaker && typeof item.bookmaker.code === 'string') {
      item.bookmaker.feedsCode = item.bookmaker.code;
      delete item.bookmaker.code;
    }

    if ('clickoutUrl' in item && typeof item.clickoutUrl?.url === 'string') {
      item.clickOutUrl = item.clickoutUrl?.url;
      delete item.clickoutUrl;
    }

    if ('isTermsExpanded' in item && typeof item.isTermsExpanded === 'boolean') {
      item.autoExpandedTermsAndConditions = item.isTermsExpanded;
      delete item.isTermsExpanded;
    }

    return item;
  });
};

export const useQuery = ({
  dataApiEndpoint,
  ...queryArgs
}: OffersSlimProps): UseSuspenseQueryResult<OffersResponseData | null> => {
  return useSuspenseQuery<OffersResponseData | null>({
    queryFn: () =>
      fetchOffersSlimData(dataApiEndpoint, queryArgs, {
        logger: console,
      }),
    queryKey: getOffersSlimCacheKey(queryArgs),
    select: data => {
      return normaliseOffersSlimData(data);
    },
  });
};
